import { useLoaderData } from "@remix-run/react";
import React, { useEffect } from "react";
import OnboardingScreen from "../components/molecules/onBoarding/onBoarding";
import { TutorProvider } from "../context/AiTutorContext";
import { LearnProvider } from "../context/LearnContext";
import { PracticeProvider } from "../context/PracticeContext";
import { useRoot } from "../context/RootContext";
import TaskScreen from "../pages/task/TaskScreen";
import { StorageService } from "../utils/StorageUtils";
export let loader = async ({ request }) => {
  const url = new URL(request.url);
  const params = Array.from(url.searchParams.entries()).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {}
  );
  return { type: "onboarding", params: params };
};
export default function OnBoarding() {
  const loaderData = useLoaderData();
  return (
    <TutorProvider>
      <PracticeProvider>
        <LearnProvider>
          <OnboardingScreen  params={loaderData.params}/>
        </LearnProvider>
      </PracticeProvider>
    </TutorProvider>
  );
}
